<template>
  <div
      class="data-input-holder"
      v-if="data.label !== 'alt tag' || RMTPermission "
      :class="getInMultiSelectionMode"
  >
    <div class="data-label">
      {{ data.label }}
    </div>
    <input
      v-model="getInputModel[this.$props.data.value]"
      type="text"
      class="data-input"
      :class="getRMTState"
      :placeholder="data.placeholder"

    >
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { storeToRefs } from 'pinia/dist/pinia';

export default {
  name: 'DataInput',
  props: ['data','val'],
  setup () {

    const RMTStore = useRMTStore();
    const {RMTPermission} = storeToRefs(RMTStore);

    return {
      RMTStore, RMTPermission
    };

  },
  computed: {
    selectedItemNum () {
      return this.RMTStore.getSelectedItemNum;
    },
    getRMTState () {
      return (!this.RMTPermission) ? 'rmt-disabled' : '';
    },
    getInputModel () {
      return this.RMTStore.getSelectedUploadedFileData;
    },
    getInMultiSelectionMode () {
      return (this.RMTStore.getInMultiSelectionMode && !this.RMTStore.inCreateCollectionMode) ? 'multi-disabled rmt-disabled' : '';
    }

  },
  methods: {

  }
};
</script>

<style scoped>
.data-input-holder {
  display: flex;
  margin-bottom:10px;
  width: 100%;
  height: 30px;
  font-size: .8em;
  align-items: center;
}
.data-label {
  width: 17%;
  min-width: 75px;
  font-weight: bold;
}
.data-input {
  width: 100%;
  height: 30px;
  padding: 15px;
  border-radius: 18px;
  background-color: white;
}

.rmt-disabled {
  background-color: transparent;
  pointer-events: none;
}

.multi-disabled {
  opacity: 0.3;
}

</style>